import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { ButtonModule, LoaderModule } from '@northfork/ng-basics'
import { AppContainerComponent } from './app-container.component'
import { AppFooterItemComponent } from './app-footer-item/app-footer-item.component'
import { AppFooterComponent } from './app-footer/app-footer.component'
import { AppGearActionComponent } from './app-gear-action/app-gear-action.component'
import { AppHeaderButtonContainerComponent } from './app-header-button-container/app-header-button-container.component'
import { AppHeaderButtonComponent } from './app-header-button/app-header-button.component'

@NgModule({
  imports: [CommonModule, LoaderModule, ButtonModule, NgbDropdownModule],
  declarations: [
    AppContainerComponent,
    AppHeaderButtonComponent,
    AppGearActionComponent,
    AppFooterComponent,
    AppFooterItemComponent,
    AppHeaderButtonContainerComponent,
  ],
  exports: [
    AppContainerComponent,
    AppHeaderButtonComponent,
    AppGearActionComponent,
    AppFooterComponent,
    AppFooterItemComponent,
    AppHeaderButtonContainerComponent,
  ],
  providers: [AppContainerComponent],
})
export class HeliosAppContainerModule {}
